import { BuildClass, fsmData } from '../../../universal';
import { React, _ } from '../../lib';
import { ConditionalObject, useStateSync } from './meta-types';
const TabControlComponent = (props, ref) => {
    const [value, setValue] = React.useState(props.value);
    const hiddenInput = React.useRef(null);
    useStateSync({
        stateVal: value,
        propVal: props.value,
        setState: setValue,
        setProp: props.onUpdate,
        compareFn: (p, s) => p === s,
    });
    const actionFocus = () => {
        if (!props.disableFocusControl) {
            hiddenInput.current?.focus();
        }
    };
    const moveSelection = (delta) => {
        const tabs = _.filter(props.tabs, x => !x.hidden);
        const max = tabs.length - 1;
        const index = tabs.map(x => x.value).indexOf(value);
        let newIndex = index + delta;
        if (newIndex < 0) {
            newIndex = 0;
        }
        else if (newIndex > max) {
            newIndex = max;
        }
        setValue(s => tabs[newIndex]?.value ?? s);
    };
    const tabWrapper = (React.createElement("div", { className: "tab-labels-wrapper" },
        React.createElement("div", { className: `tab-sibling tab-sibling-before` }, props.toolbarBefore),
        React.createElement("div", { className: "tabs-wrapper-inner", onClick: actionFocus },
            React.createElement("div", { className: "ui5-tab-labels" }, fsmData(props.tabs, {
                filter: tab => !tab.hidden,
                map: tab => (React.createElement("div", { key: String(tab.value ?? tab.label), className: BuildClass({
                        [tab.label
                            .replace(/\s/g, '-')
                            .replace(/\./g, '')
                            .toLowerCase()]: true,
                        'tab-label': true,
                        selected: tab.value === value,
                        disabled: tab.disabled ?? false,
                    }), title: tab.tooltip, onMouseDown: () => {
                        if (!tab.disabled) {
                            setValue(tab.value);
                        }
                    }, style: {
                        maxWidth: tab.tabWidth ? `${tab.tabWidth}px` : 'none',
                    } },
                    React.createElement("div", { className: "tab-box" }),
                    React.createElement("div", { className: "tab-text", title: tab.tooltip ?? tab.label }, tab.label))),
            }))),
        React.createElement("div", { className: `tab-sibling tab-sibling-after` }, props.toolbarAfter)));
    const content = (React.createElement("div", { className: "tab-containers" }, fsmData(props.tabs, {
        filter: tab => !tab.hidden && tab.value === value,
        map: tab => (React.createElement("div", { key: tab.label, className: BuildClass({
                'tab-container': true,
                [BuildClass(tab.className ??
                    String(tab.value)
                        .replace(/\s/g, '')
                        .replace(/\./g, '')
                        .toLowerCase())]: true,
                selected: tab.value === value,
            }) }, ConditionalObject(!tab.disabled, tab.content))),
    })));
    const focusController = (React.createElement("div", { className: "focus-controller" },
        React.createElement("input", { ref: hiddenInput, onKeyDown: e => {
                switch (e.keyCode) {
                    case 37:
                    case 38:
                        moveSelection(-1);
                        break;
                    case 39:
                    case 40:
                        moveSelection(+1);
                        break;
                    default:
                        return;
                }
                e.preventDefault();
                e.stopPropagation();
            } })));
    let children;
    children =
        props.position === 'bottom' || props.position === 'right'
            ? [content, tabWrapper]
            : [tabWrapper, content];
    React.useImperativeHandle(ref, () => null);
    return (React.createElement("div", { className: BuildClass({
            [BuildClass(props.className)]: true,
            'ui5-tab-control': true,
            vertical: props.position === 'left' || props.position === 'right',
            right: props.position === 'right',
            bottom: props.position === 'bottom',
        }), style: props.style },
        focusController,
        ...children));
};
export const TabControl = React.forwardRef(TabControlComponent);
//# sourceMappingURL=tabs.js.map